export const MAIL_API_TOKEN_NAME = 'MAIL_API';

export const DefaultMailApiConfig = {
    debug: false,
    withCredentials: false,
};
